( function( $ ) {
        let avatarId = null;
        let avatarUrl = null;

        // Add class to selected avatar to change border colour on click
        $( '.avatar-wrap' ).on( 'click', function() {
            $( '.avatar-wrap' ).removeClass( 'avatar-selected' );
            $( this ).toggleClass( 'avatar-selected' );

            avatarId = $( this ).find( 'img' ).data( 'avatar-id' );
            avatarUrl = $( this ).find( 'img' ).attr( 'src' );
        });

        // Submit the avatar choice form
        $( 'form#zl-smart-avatars-choice' ).on( 'submit', function( e ) {
            e.preventDefault();

            $.ajax({
                type: 'post',
                url: zl_smart_avatars_ajax_object.ajax_url,
                data: {
                    action: 'user_change_avatar',
                    avatar_id: avatarId,
                    avatar_url: avatarUrl,
                    nonce: zl_smart_avatars_ajax_object.nonce
                },
                success: function( response ) {
                    if ( response.success ) {
                        let newAvatarUrl = response.data.avatar_url;
                        console.log( newAvatarUrl );
                        $( '#item-header a .avatar' ).attr( 'src', newAvatarUrl );
                    }
                },
                error: function( error ) {
                    console.log( error );
                }
            });
        });

}( jQuery ) );
